import React from 'react';
import Loader from '../components/loader';
import HeroHeader from '../components/HeroHeader';
import Donate from '../components/donate';
import MetaTags from '../common-components/MetaTags';

class DonatePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    //  document.title = "Donate - Learn Quran Easily";
    // document.description = "Learn Quran Easily"
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000); // Simulate a 3-second loading delay
  }


  render() {
    const breadcrumbs = [
        { label: 'Home', href: '#', isCurrentPage: false },
        { label: 'Pages', href: '#', isCurrentPage: false },
        { label: 'Donate Us', href: '#', isCurrentPage: true },
      ];

    return <>
    <MetaTags
      title="Donate - Learn Quran Easily"
      description="Support Learn Quran Easily by making a donation. Help us spread authentic Quranic education and Islamic knowledge worldwide."
      keywords="Donate to Learn Quran Easily, Support Quran Learning, Charity, Islamic Education Donation"
      author="Learn Quran Easily Team"
      url="https://learnquraneasily.in/donate"
      image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
    />
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="Donate Us" breadcrumbs={breadcrumbs} />
          <Donate />
        </>}
    </>
  }
}

export default DonatePage;
